module.exports = __webpack_public_path__ + "img/release-select.c4291534.png";